import Typography from "@mui/material/Typography";
import {Link} from "@mui/material";

export default function Copyright(props) {
    return (
            <Typography
                variant="caption"
                {...props}
                sx={[
                    {
                        color: 'white',
                        fontSize: '0.7rem',
                        lineHeight: 1.4,
                    },
                    ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
                ]}
            >
                {'Copyright © '}{new Date().getFullYear()}{' '}
                <Link color="inherit" href="">
                    Alosys
                </Link>
                {'.'} <br/>
                {'All rights reserved.'}
            </Typography>

    );
}